/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Coaching_Invitation_RowInputs */

const en_us2_coaching_invitation_row = /** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.group} invited you to the group`)
};

const pt_br2_coaching_invitation_row = /** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.group} convidou você para a turma`)
};

const pt_pt2_coaching_invitation_row = /** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.group} convidou você para a turma`)
};

/** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */
const es_419_coaching_invitation_row = en_us2_coaching_invitation_row;

/** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */
const fr_fr2_coaching_invitation_row = en_us2_coaching_invitation_row;

/** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */
const de_de2_coaching_invitation_row = en_us2_coaching_invitation_row;

/** @type {(inputs: Coaching_Invitation_RowInputs) => LocalizedString} */
const it_it2_coaching_invitation_row = en_us2_coaching_invitation_row;

/**
* | output |
* | --- |
* | "{group} invited you to the group" |
*
* @param {Coaching_Invitation_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_invitation_row = /** @type {((inputs: Coaching_Invitation_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Invitation_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_invitation_row(inputs)
	if (locale === "es-419") return es_419_coaching_invitation_row(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_invitation_row(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_invitation_row(inputs)
	if (locale === "de-DE") return de_de2_coaching_invitation_row(inputs)
	if (locale === "it-IT") return it_it2_coaching_invitation_row(inputs)
	return en_us2_coaching_invitation_row(inputs)
});
export { coaching_invitation_row as "coaching.invitation_row" }